<div class="container dd-checkout-success">
  <h1 class="font-title">Thank you</h1>
  <p>Your payment was received. Your order is being confirmed.</p>

  @if (loading()) {
    <p>Loading receipt…</p>
  } @else if (error() && !order()) {
    <p class="woocommerce-error">{{ error() }}</p>
  }

  @if (order(); as o) {
    <p>
      <button type="button" class="button" (click)="downloadPdf()" [disabled]="downloading()">
        {{ downloading() ? 'Downloading…' : 'Download PDF' }}
      </button>
      <a class="button" routerLink="/shop">Continue shopping</a>
    </p>

    @if (error()) {
      <p class="woocommerce-error">{{ error() }}</p>
    }

    <table class="shop_table">
      <thead>
        <tr>
          <th colspan="2">Order {{ o.orderNumber }} — {{ o.status }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Customer</th>
          <td>
            {{ customerName(o) }}<br />
            {{ o.customerEmail }}<br />
            {{ o.customerPhone }}
          </td>
        </tr>
        @for (line of o.lines; track line.id) {
          <tr>
            <td>{{ line.name }} &times; {{ line.quantity }}</td>
            <td>${{ line.lineTotal | number: '1.2-2' }}</td>
          </tr>
        }
        <tr>
          <th>Subtotal</th>
          <td>${{ o.subtotal | number: '1.2-2' }}</td>
        </tr>
        <tr>
          <th>Tax</th>
          <td>${{ o.taxAmount | number: '1.2-2' }}</td>
        </tr>
        <tr>
          <th>Total</th>
          <td>
            <strong>${{ o.total | number: '1.2-2' }} {{ o.currency.toUpperCase() }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  }
</div>
